export { default } from '@features/post'

export const config = { amp: 'hybrid' }
